// Trata adicionar/remover cartões de investigador no formulário do projeto

document.addEventListener("turbo:load", () => {
  // Obtém os elementos principais do DOM
  const addBtn = document.getElementById("add-project-researcher-btn");
  const select = document.getElementById("add_project_researcher_id");
  const list = document.getElementById("project-researchers-list");
  const template = document.getElementById("project-researcher-template");

  // Se faltar algum elemento, não faz nada
  if (!addBtn || !select || !list || !template) return;

  // Ao carregar, remove do select os investigadores já presentes nos cartões
  Array.from(document.querySelectorAll('input[name*="[researcher_id]"]')).forEach(input => {
    const id = input.value;
    if (!id) return;
    if (select.tomselect) {
      // Remove do TomSelect se estiver ativo
      select.tomselect.removeOption(id);
    } else {
      // Remove do DOM do select normal
      const option = select.querySelector(`option[value="${id}"]`);
      if (option) option.remove();
    }
  });

  // Função para devolver o pesquisador ao select/TomSelect
  function handleRemoveCard(card, researcherId, researcherName, researcherImg, option) {
    // Cria um novo option para devolver ao select (DOM)
    const newOption = document.createElement("option");
    newOption.value = researcherId;
    newOption.textContent = researcherName;
    newOption.dataset.src = researcherImg;

    // Busca SEMPRE do card (garantido pelo data-attribute no HTML)
    let email = card.getAttribute('data-email') || "";
    let orcid = card.getAttribute('data-orcid') || "";

    // Seta nos data attributes do option
    if (email) newOption.dataset.email = email;
    if (orcid) newOption.dataset.orcid = orcid;
    newOption.setAttribute('data-option', 'researcher');

    // Insere na ordem alfabética (depois do primeiro option)
    let inserted = false;
    for (let i = 1; i < select.options.length; i++) {
      if (select.options[i].text.localeCompare(researcherName, undefined, { sensitivity: 'base' }) > 0) {
        select.insertBefore(newOption, select.options[i]);
        inserted = true;
        break;
      }
    }
    if (!inserted) select.appendChild(newOption);

    // Se TomSelect estiver ativo, remove e adiciona a opção corretamente
    if (select.tomselect) {
      select.tomselect.removeOption(researcherId);
      select.tomselect.addOption({
        id: researcherId,
        name: researcherName,
        src: researcherImg,
        email: email,
        orcid: orcid,
        option: 'researcher'
      });
      select.tomselect.refreshOptions(false);
    }
  }

  // Ao carregar, associa o evento de remover a todos os cards já existentes
  Array.from(list.querySelectorAll('[data-action="nested-form#remove"]')).forEach(removeBtn => {
    removeBtn.addEventListener("click", function() {
      // O card pode ser removido do DOM ou apenas escondido (caso de _destroy)
      const card = removeBtn.closest('.nested-form-wrapper');
      if (!card) return;
      // Só devolve ao select se o campo hidden _destroy for marcado (ou seja, vai ser removido)
      // e se o card não for novo (já existe no BD)
      const inputResearcherId = card.querySelector('input[name$="[researcher_id]"]');
      const researcherId = inputResearcherId ? inputResearcherId.value : null;
      const nameSpan = card.querySelector('span[style*="font-size: 1.08rem"]');
      const researcherName = nameSpan ? nameSpan.textContent : "";
      const imgTag = card.querySelector('img.rounded-circle');
      const researcherImg = imgTag ? imgTag.src : "";
      // Só devolve se houver id
      if (researcherId) {
        handleRemoveCard(card, researcherId, researcherName, researcherImg);
      }
    });
  });

  // Ao clicar no botão de adicionar investigador
  addBtn.addEventListener("click", function(e) {
    e.preventDefault();
    // Obtém o id do investigador selecionado
    const researcherId = select.value;
    if (!researcherId) return;

    // Vai buscar o option correspondente ao investigador selecionado
    const option = select.querySelector(`option[value="${researcherId}"]`);
    if (!option) return;
    // Vai buscar o nome e a imagem do investigador
    const researcherName = option.textContent || "";
    const researcherImg = option.dataset.src || "";

    // Clona o template do cartão e substitui o índice por um valor único
    const uniqueIndex = Date.now();
    let html = template.innerHTML.replace(/NEW_RECORD/g, uniqueIndex);
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Preenche o campo hidden com o id do investigador
    const input = tempDiv.querySelector('input[name$="[researcher_id]"]');
    if (input) input.value = researcherId;

    // Preenche o nome e a imagem no cartão clonado
    const nameSpan = tempDiv.querySelector('span[style*="font-size: 1.08rem"]');
    if (nameSpan) nameSpan.textContent = researcherName;
    const imgTag = tempDiv.querySelector('img.rounded-circle');
    if (imgTag && researcherImg) imgTag.src = researcherImg;

    // Adiciona o cartão ao início da lista de cartões
    const card = tempDiv.firstElementChild;

    // COPIA data-email/data-orcid do option para o card (para garantir que o handleRemoveCard funciona)
    if (option.dataset.email) card.setAttribute('data-email', option.dataset.email);
    if (option.dataset.orcid) card.setAttribute('data-orcid', option.dataset.orcid);

    list.insertBefore(card, list.firstChild);

    // Remove o investigador do select (TomSelect ou normal)
    if (select.tomselect) {
      select.tomselect.removeOption(researcherId);
      select.tomselect.clear();
    } else {
      option.remove();
      select.value = "";
    }

    // Ao clicar no botão de remover do cartão
    const removeBtn = card.querySelector('[data-action="nested-form#remove"]');
    if (removeBtn) {
      removeBtn.addEventListener("click", function() {
        card.remove();
        handleRemoveCard(card, researcherId, researcherName, researcherImg, option);
      });
    }
  });
});
